__webpack_require__.p = "https://luquinhas.concordia.dev.br/";